import { render, staticRenderFns } from "./setWatermarkDialog.vue?vue&type=template&id=b235502c&scoped=true&"
import script from "./setWatermarkDialog.vue?vue&type=script&lang=js&"
export * from "./setWatermarkDialog.vue?vue&type=script&lang=js&"
import style0 from "./setWatermarkDialog.vue?vue&type=style&index=0&id=b235502c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b235502c",
  null
  
)

export default component.exports